<template>
  <div>
    <div :class="`${node.type == 'group' ? 'node-hover' : ''}`">
      <div
          :style="{'margin-left': 25 * depth + 'px'}"
      >
        <div class="d-flex justify-content-between">
          <div  class="node" @click="expanded = !expanded">
            <span v-if="hasChildren">{{ expanded ? '&#9660' : '&#9658'}}</span>
            <span v-if="node.type == 'group'">{{ node.name }}</span>
          </div>
        </div>
        <div
            class="d-flex cursor-initial justify-content-between bg-black-light rounded-8 p-1 mb-1"
            v-if="node.type == 'endpoint'"
        >
          <p class="mb-0">{{ node.name }}</p>
          <div class="d-flex">
            Weight:{{  node.weight }}
            <span class="mx-1">
               Score:{{ node.weighted_score || 0 }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <hr class="mb-1 mt-0" v-if="type == 'group'">
    <template v-if="expanded">
      <TreeComponentItem
          v-for="item in node.active_child"
          :key="item.name"
          :parent="node"
          :depth="depth + 1"
          :node="item"
      />
    </template>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";

const props = defineProps({
  node: {
    type: Object,
    required: true
  },
  depth: {
    type: Number,
    default: 0
  },
  parent: {
    default: () => []
  }
})

const expanded = ref(true)

const hasChildren = computed(() => {
  return props.node.active_child.length
})

const type = computed(() => {
  return props.node.type
})

</script>

<style scoped>
.bg-black-light {
  background: #00000024;
}
.rounded-8 {
  border-radius: 8px;
}
.node {
  cursor: pointer;
}
.node-hover {
  padding: 10px 2px;
}
.node-hover:hover {
  background: #fffeec;
}
.cursor-initial {
  cursor: initial;
}
.cursor-pointer {
  cursor: pointer;
}
.w-30 {
  width: 30px;
}
.w-20 {
  width: 20px;
}
.z-999 {
  z-index: 999;
}
.w-44 {
  width: 44px;
}
</style>
